<template>
  <div class="flex flex-col w-full overflow-hidden">
    <div class="w-full h-full flex-grow overflow-y-auto" @scroll="handleScroll">
      <div class="w-full max-w-content mx-auto">
        <div class="h-10" ref="spacer"></div>
        <base-back-button />
        <div class="px-4 sm:px-0">
          <h2 class="font-sans text-2xl uppercase mb-1" ref="pageTitle">Title</h2>
          <p class="text-neutral">subtitle</p>
          <div class="leading-1 mb-4">
            <p v-for="i in 100" :key="i">Linea {{ i }}</p>
          </div>
        </div>
      </div>
    </div>
    <base-footer>
      <template slot="ls">
        <span>Left</span>
      </template>
      <template slot="rs">
        <span>Right</span>
      </template>
    </base-footer>
  </div>
</template>

<script>
import { handleScrollMixin } from '@/mixins/appMixin'

export default {
  name: 'basePage',
  mixins: [handleScrollMixin],
  data: function () {
    return {
      pageTitle: 'Base template page'
    }
  }
}
</script>

<style lang="scss" scoped></style>
